export default "__VITE_ASSET__BFORf4Za__"